import { SelectOption } from '../components/Select'

export default {
  get barcodeTypeSelectOptions (): SelectOption[] {
    return [
      { value: 'azteccode', name: 'Aztec Code' },
      { value: 'rationalizedCodabar', name: 'Codabar' },
      { value: 'code11', name: 'Code 11' },
      { value: 'dotcode', name: 'DotCode' },
      { value: 'maxicode', name: 'MaxiCode' },
      { value: 'msi', name: 'MSI Modified Plessey' },

      { value: 'Code 25', name: 'Code 25', disabled: true },
      { value: 'code2of5', name: 'Code 25' },
      { value: 'iata2of5', name: 'IATA 2 of 5' },
      { value: 'industrial2of5', name: 'Industrial 2 of 5' },
      { value: 'interleaved2of5', name: 'Interleaved 2 of 5 (ITF)' },
      { value: 'itf14', name: 'ITF 14' },

      { value: 'Code 39', name: 'Code 39', disabled: true },
      { value: 'code39', name: 'Code 39' },
      { value: 'code39ext', name: 'Code 39 Extended' },
      { value: 'code32', name: 'Italian Pharmacode (Code 32)' },
      { value: 'pzn', name: 'Pharmazentralnummer (PZN)' },

      { value: 'Code 93', name: 'Code 93', disabled: true },
      { value: 'code93', name: 'Code 93' },
      { value: 'code93ext', name: 'Code 93 Extended' },

      { value: 'Code 128', name: 'Code 128', disabled: true },
      { value: 'code128', name: 'Code 128' },
      { value: 'ean14', name: 'EAN 14' },
      { value: 'gs1-128', name: 'GS1 128 (EAN 128)' },
      { value: 'sscc18', name: 'SSCC 18' },

      { value: 'Data Matrix', name: 'Data Matrix', disabled: true },
      { value: 'datamatrix', name: 'Data Matrix' },
      { value: 'gs1datamatrix', name: 'GS1 Data Matrix' },

      { value: 'EAN', name: 'EAN', disabled: true },
      { value: 'ean8', name: 'EAN 8' },
      { value: 'ean13', name: 'EAN 13' },
      { value: 'isbn', name: 'ISBN' },
      { value: 'ismn', name: 'ISMN' },
      { value: 'issn', name: 'ISSN' },

      { value: 'GS1 DataBar', name: 'GS1 DataBar', disabled: true },
      { value: 'databartruncated', name: 'GS1 DataBar Truncated' },
      { value: 'databarlimited', name: 'GS1 DataBar Limited' },
      { value: 'databarexpanded', name: 'GS1 DataBar Expanded' },
      { value: 'databarexpandedstacked', name: 'GS1 DataBar Expanded Stacked' },
      { value: 'databaromni', name: 'GS1 DataBar Omnidirectional' },
      { value: 'databarstacked', name: 'GS1 DataBar Stacked' },
      { value: 'databarstackedomni', name: 'GS1 DataBar Stacked Omnidirectional' },

      { value: 'PDF417', name: 'PDF417', disabled: true },
      { value: 'pdf417', name: 'PDF417' },
      { value: 'pdf417compact', name: 'Compact PDF417' },

      { value: 'Postal Code', name: 'Postal Code', disabled: true },
      { value: 'onecode', name: 'USPS Intelligent Mail' },
      { value: 'planet', name: 'USPS PLANET' },
      { value: 'postnet', name: 'USPS POSTNET' },

      { value: 'Telepen', name: 'Telepen', disabled: true },
      { value: 'telepen', name: 'Telepen' },
      { value: 'telepennumeric', name: 'Telepen Numeric' },

      { value: 'QR Code', name: 'QR Code', disabled: true },
      { value: 'qrcode', name: 'QR Code' },
      { value: 'microqrcode', name: 'Micro QR Code' },
      { value: 'gs1qrcode', name: 'GS1 QR Code' },

      { value: 'UPC', name: 'UPC', disabled: true },
      { value: 'upca', name: 'UPC-A' },
      { value: 'upce', name: 'UPC-E' }
    ]
  },

  get fontStyleSelectOptions () {
    return [
      { value: 'normal', name: 'Normal' },
      { value: 'bold', name: 'Bold' },
      { value: 'italic', name: 'Italic' },
      { value: 'italic bold', name: 'Italic bold' }
    ]
  },

  get textAlignSelectOptions () {
    return [
      { value: 'left', name: 'Left' },
      { value: 'center', name: 'Center' },
      { value: 'right', name: 'Right' }
    ]
  },

  get fontFamilySelectOptions() {
    return [
      { value: 'Arial', name: 'Arial' },
      { value: 'Verdana', name: 'Verdana' },
      { value: 'Tahoma', name: 'Tahoma' },
      { value: 'Trebuchet MS', name: 'Trebuchet MS' },
      { value: 'Times New Roman', name: 'Times New Roman' },
      { value: 'Georgia', name: 'Georgia' },
      { value: 'Garamond', name: 'Garamond' },
      { value: 'Courier New', name: 'Courier New' },
      { value: 'Brush Script MT', name: 'Brush Script MT' },
      // Google Fonts
      { value: 'Roboto', name: 'Roboto' },
      { value: 'Open Sans', name: 'Open Sans' },
      { value: 'Lato', name: 'Lato' },
      { value: 'Montserrat', name: 'Montserrat' },
      { value: 'Raleway', name: 'Raleway' },
      { value: 'Oswald', name: 'Oswald' },
      { value: 'Poppins', name: 'Poppins' },
      { value: 'Nunito', name: 'Nunito' },
      { value: 'Merriweather', name: 'Merriweather' },
      { value: 'PT Sans', name: 'PT Sans' },
      { value: 'Playfair Display', name: 'Playfair Display' },
      { value: 'Rubik', name: 'Rubik' },
      { value: 'Source Sans Pro', name: 'Source Sans Pro' },
      { value: 'Josefin Sans', name: 'Josefin Sans' },
      { value: 'Fira Sans', name: 'Fira Sans' },
      { value: 'Noto Sans', name: 'Noto Sans' },
      { value: 'Inconsolata', name: 'Inconsolata' },
      { value: 'Dancing Script', name: 'Dancing Script' },
      { value: 'Pacifico', name: 'Pacifico' }
    ];
  }
}
